import { Injectable } from '@angular/core';
import { Dexie, Table } from 'dexie';
import { Types } from 'shared-lib';

@Injectable({
  providedIn: 'root',
})
export class DatabaseService extends Dexie {
  imageCache!: Table<Types.IImageCacheSchema, number>;

  constructor() {
    super('tialtonivel.formToReport');
    this.version(1).stores({
      imageCaches: 'id, name, originalname, mimetype, size, base64, eTag',
    });
  }

  async readAll<T>(table: Table<T, number>): Promise<T[]> {
    return await table.toArray();
  }

  async readOne<T>(
    table: Table<T, number>,
    id: number
  ): Promise<T | undefined> {
    const result = await table.where('id').equals(id).toArray();
    if (!result || result.length != 1) {
      return undefined;
    }
    return result.at(0);
  }

  async create<T>(table: Table<T, number>, entity: T) {
    return await table.add(entity);
  }

  async update<T>(table: Table<T, number>, entity: T) {
    return await table.add(entity);
  }

  // async remove<T>(table: Table<T, number>, id: number) {
  //   return (await this.readOne<IImageCacheSchema>(table, id))?.
  // }
}
